import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/**
 * An impersonation start or end in flight. The identity swap ends in a full
 * page load, so this only lives until the browser navigates; it drives the
 * full-screen "Switching to …" overlay in the meantime.
 */
export type ImpersonationTransition =
  | { kind: 'start'; name: string }
  | { kind: 'end' }

interface AuthState {
  isSigningOut: boolean
  impersonationTransition: ImpersonationTransition | null
}

const initialState: AuthState = {
  isSigningOut: false,
  impersonationTransition: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSigningOut: (state, action: PayloadAction<boolean>) => {
      state.isSigningOut = action.payload
    },
    setImpersonationTransition: (
      state,
      action: PayloadAction<ImpersonationTransition | null>
    ) => {
      state.impersonationTransition = action.payload
    },
    resetAuthState: (state) => {
      state.isSigningOut = false
      state.impersonationTransition = null
    }
  }
})

export const { setSigningOut, setImpersonationTransition, resetAuthState } =
  authSlice.actions
export const authReducer = authSlice.reducer

// Selectors
export const selectIsSigningOut = (state: { auth: AuthState }) =>
  state.auth.isSigningOut
export const selectImpersonationTransition = (state: { auth: AuthState }) =>
  state.auth.impersonationTransition
export const selectShouldHideLayout = (state: { auth: AuthState }) =>
  state.auth.isSigningOut
